import { observer } from 'mobx-react-lite';
import * as React from 'react';

import './breakdown-section.css';

import { CardType } from '../contracts';
import { Store } from '../stores/store';
import { formatAmount } from '../utils/amounts';

interface IProps {
    store: Store;
}

export const BreakdownSection = observer<IProps>(({ store }) => {
    return (
        <div className='breakdown-section'>
            <h3>You got charged extra  <em>{formatAmount(store.estimatedBankFees, store.bankChargeAmount.currency)}</em></h3>
            <p className='big'>
                or about <em>{`${store.estimatedBankFeesPercentage.toFixed(2)}%`}</em> of your transaction.
            </p>

            <div className='breakdown-wrapper'>
                <p style={{ textAlign: 'right', fontSize: '18px' }}>Your transaction breakdown:</p>
                <div className='breakdown'>
                    <div className='minus'>
                        -
                    </div>
                    <div>
                        <div className='breakdown-label'>You paid</div>
                        <div className='breakdown-amount'>{formatAmount(store.totalBankCharge, store.bankChargeAmount.currency)}</div>
                    </div>
                    <div>
                        <div className='breakdown-label'>{store.cardType === CardType.Visa ? 'Visa' : 'Mastercard'} charged your bank</div>
                        <div className='breakdown-amount'>{formatAmount(store.cardType === CardType.Visa ? store.estimatedVisaCharge : store.estimatedMastercardCharge, store.bankChargeAmount.currency)}</div>
                    </div>
                    <hr />
                    <div>
                        <div className='breakdown-label'><em>Your bank extra fees</em></div>
                        <div className='breakdown-amount'><em>{formatAmount(store.estimatedBankFees, store.bankChargeAmount.currency)}</em></div>
                    </div>
                </div>
            </div>
            <div className='btn-wrapper'>
                <button type='button' className='btn' onClick={store.goBack}>Back</button>
                <button type='button' className='btn btn-green' onClick={store.goToBankCompare}>Continue</button>
            </div>
        </div>
    );
});
